import type { ApolloError } from 'apollo-client';

import type { SubmissionStatusEnum, SubmitterListTimestamp, UserProfile } from 'bundles/grading/api/types';

// base interface for a SGASubmitter type
type SubmitterBase = {
  /**
   * Used for submitterId component of url.
   * TODO: Need to transition over in future and allow backwards compatibility.
   * TODO: consider renaming it to `routeSubmitterId`
   */
  id: string;
  /**
   * Original submitterId returned from BE. This id has the same format in response to
   * SubmissionData and SubmitterList queries. This property is used to compare submitterId values
   * from those two queries when needed.
   */
  submitterId: string;
  /**
   * For individual submitter, name is the displayName that is processed on BE for different situations.
   * For team it's the team's name
   */
  name: string;
  submissionStatus?: SubmissionStatusEnum | null;
  /**
   * null when no submission
   */
  submittedAt?: SubmitterListTimestamp | null;
  submissionDeadline: SubmitterListTimestamp;
  isSubmissionGraded: boolean;
};

// SGA Learner type
export type Learner = SubmitterBase & UserProfile;

// SGA Team type
export type Team = SubmitterBase & {
  teamVersion: number;
  userProfiles: UserProfile[];
};

// unified SGASubmitter type
export type SGASubmitter = Learner | Team;

export type FetchStatus = {
  loading: boolean;
  error?: ApolloError;
};

export function isTeamSubmitter(submitter: SGASubmitter): submitter is Team {
  return (submitter as Team).userProfiles !== undefined;
}

export function isLearnerSubmitter(submitter: SGASubmitter): submitter is Learner {
  return (submitter as Learner).userId !== undefined;
}

// basic button info for linear navigation button
export type LinearNavigationButtonInfo = {
  title: string;
  questionId: string;
  rubricId?: string;
} | null;

// button's action information for linear navigation
export type LinearNavigationButtonAction = {
  title: string;
  buttonCallback?: () => void;
};

export type NavigationShortcutCallbacks = {
  nextButtonCallback?: () => void;
  previousButtonCallback?: () => void;
};
